const _excluded = ["children", "onNext", "nextCTA", "disableNext", "onSkip", "skipCTA", "sectionLabel", "scrollable", "headerComponent", "className", "disabledCallback"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import clsx from 'clsx';
import { Button } from 'onboarding-components';
import { useTranslation } from 'common/i18n/hooks';
import { HeaderProps, SectionProps } from '../events/types';
import styles from './index.module.styl';
import { SectionHeader } from './section-header';
export const SectionContent = (props: React.PropsWithChildren<HeaderProps & SectionProps>) => {
  const {
    t
  } = useTranslation();
  const {
      children,
      onNext,
      nextCTA,
      disableNext = false,
      onSkip,
      skipCTA,
      sectionLabel,
      scrollable,
      headerComponent,
      className,
      disabledCallback
    } = props,
    headerProps = _objectWithoutProperties(props, _excluded);
  return <div className={clsx(styles.subStepPadding, className)} data-sentry-component="SectionContent" data-sentry-source-file="section-content.tsx">
      {headerComponent}
      <div className={styles.section}>
        {sectionLabel && <div className={styles.substep}>{sectionLabel}</div>}
        <div className={styles.sectionContent}>
          <SectionHeader {...headerProps} data-sentry-element="SectionHeader" data-sentry-source-file="section-content.tsx" />
          {children}
          <div className={styles.footerButtons} onClick={() => {
          if (disableNext && disabledCallback) {
            disabledCallback();
          }
        }}>
            {onNext && <Button onClick={onNext} size='small' disabled={disableNext}>
                {nextCTA || t("onboarding.next")}
              </Button>}
            {onSkip && <Button onClick={onSkip} variant={"inline"} includeArrow={false} size='small'>
                {skipCTA || t("onboarding.skip")}
              </Button>}
          </div>
        </div>
      </div>
    </div>;
};